/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AppActionNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Appdiscovery.AppActionNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'AppActionNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const InstallApp: BridgeCommands.Command<
    Types.Nvapp.Appdiscovery.InstallAppParameters,
    Types.Nvapp.Appdiscovery.InstallAppReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'InstallApp',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const UninstallApp: BridgeCommands.Command<
    Types.Nvapp.Appdiscovery.UninstallAppParameters,
    Types.Nvapp.Appdiscovery.UninstallAppReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'UninstallApp',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppStatus: BridgeCommands.Command<
    Types.Nvapp.Appdiscovery.GetAppStatusParameters,
    Types.Nvapp.Appdiscovery.GetAppStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'GetAppStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppsStatus: BridgeCommands.Command<
    Types.Nvapp.Appdiscovery.GetAppsStatusParameters,
    Types.Nvapp.Appdiscovery.GetAppsStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'GetAppsStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchApp: BridgeCommands.Command<
    Types.Nvapp.Appdiscovery.LaunchAppParameters,
    Types.Nvapp.Appdiscovery.LaunchAppReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'AppDiscovery',
    method: 'LaunchApp',
    persistent: false
};

export const Appdiscovery = {
AppActionNotification,
InstallApp,
UninstallApp,
GetAppStatus,
GetAppsStatus,
LaunchApp
};
